import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ImpersonatePage } from '@/features/admin/impersonate'

export const Route = createFileRoute('/_authenticated/impersonate/')({
  component: ImpersonatePage,
  beforeLoad: requireRole(['admin']),
})
